module.exports = __webpack_public_path__ + "static/media/toggle-right.121fcd00.svg";